export enum Genders {
  male = 'MALE',
  female = 'FEMALE',
}
